/**
 * @file Generated by js-routes 2.3.6. Based on Rails 8.0.4 routes of Mampf::Application.
 * @version 2b104a0e97d179866917829a7ffc9759f70d3cf038177472746498c74b1a23fc
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
(typeof window !== 'undefined' ? window : this).Routes = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using (typeof window !== 'undefined' ? window : this).Routes = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (prefix) {
                        key = prefix + "[" + key + "]";
                    }
                    const subvalue = this.default_serializer(prop, key);
                    if (subvalue.length) {
                        result.push(subvalue);
                    }
                }
            }
            else {
                result.push(this.is_not_nullable(value) ||
                    true
                    ? encodeURIComponent(prefix) +
                        "=" +
                        encodeURIComponent("" + (value !== null && value !== void 0 ? value : ""))
                    : encodeURIComponent(prefix));
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("NIL", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{
  /**
   * Generates rails route to
   * /submissions/:id/accept(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  accept_submission_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/add_consent(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_consent_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"add_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/add_correction(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_correction_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_correction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/add_forum(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_forum_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_forum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/add_item(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_item_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /watchlists/add_medium/:medium_id(.:format)
   * @param {any} medium_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_medium_to_watchlist_path: __jsr.r({"medium_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"watchlists"],[2,[7,"/"],[2,[6,"add_medium"],[2,[7,"/"],[2,[3,"medium_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/add_reference(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_reference_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_reference"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/add_screenshot(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_screenshot_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /watchlists/add(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_watchlist_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"watchlists"],[2,[7,"/"],[2,[6,"add"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /administration(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  administration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"administration"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /administration/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  administration_search_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /altcha(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  altcha_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"altcha"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /annotations/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  annotation_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"annotations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /annotations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  annotations_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"annotations"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /announcements(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  announcements_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /answers/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  answer_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /answers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  answers_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"answers"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /areas/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  area_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /areas(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  areas_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"areas"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /talks/:id/assemble(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assemble_talk_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"talks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assemble"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /assignments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assignment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /assignments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  assignments_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"assignments"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /tutorials/:id/assignments/:ass_id/bulk_download_corrections(.:format)
   * @param {any} id
   * @param {any} ass_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bulk_download_corrections_path: __jsr.r({"id":{"r":true},"ass_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"ass_id"],[2,[7,"/"],[2,[6,"bulk_download_corrections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials/:id/assignments/:ass_id/bulk_download_submissions(.:format)
   * @param {any} id
   * @param {any} ass_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bulk_download_submissions_path: __jsr.r({"id":{"r":true},"ass_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"ass_id"],[2,[7,"/"],[2,[6,"bulk_download_submissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials/:id/assignments/:ass_id/bulk_upload(.:format)
   * @param {any} id
   * @param {any} ass_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bulk_upload_corrections_path: __jsr.r({"id":{"r":true},"ass_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"ass_id"],[2,[7,"/"],[2,[6,"bulk_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /answers/:id/cancel_edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_edit_answer_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /assignments/:id/cancel_edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_edit_assignment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/cancel_edit_correction(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_edit_correction_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_edit_correction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/cancel_edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_edit_submission_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials/:id/cancel_edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_edit_tutorial_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/cancel_import_media(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_import_media_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"cancel_import_media"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/cancel_import_vertex(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_import_vertex_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"cancel_import_vertex"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /assignments/cancel_new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_new_assignment_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[6,"cancel_new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/cancel_new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_new_submission_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[6,"cancel_new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials/cancel_new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_new_tutorial_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[6,"cancel_new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/cancel_publication(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_publication_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_publication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questions/:id/cancel_question_basics(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_question_basics_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_question_basics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /remarks/:id/cancel_remark_basics(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_remark_basics_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"remarks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_remark_basics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questions/:id/cancel_solution_edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_solution_edit_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_solution_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/cancel_action(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_submission_action_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /terms/cancel_term_edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_term_edit_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[6,"cancel_term_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users/cancel(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_user_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /vouchers/cancel(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  cancel_voucher_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vouchers"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /watchlists/change_visiblity(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  change_visibility_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"watchlists"],[2,[7,"/"],[2,[6,"change_visiblity"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /chapters/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  chapter_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chapters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /chapters(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  chapters_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chapters"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /media/:id/check_annotation_visibility(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  check_annotation_visibility_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_annotation_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /quiz_certificates/:id/claim(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  claim_quiz_certificate_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quiz_certificates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"claim"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /administration/classification(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  classification_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"classification"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /main/comments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  comments_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"main"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /commontator
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_path: __jsr.r({}, [2,[7,"/"],[6,"commontator"]]),

  /**
   * Generates rails route to
   * /commontator/threads/:id/close(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_close_thread_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/comments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_comment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/comments/:id/delete(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_delete_comment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/comments/:id/downvote(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_downvote_comment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"downvote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/comments/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_edit_comment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/threads/:thread_id/comments/new(.:format)
   * @param {any} thread_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_new_thread_comment_path: __jsr.r({"thread_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/threads/:id/reopen(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_reopen_thread_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reopen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/threads/:id/subscribe(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_subscribe_thread_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/threads/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_thread_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/threads/:thread_id/comments(.:format)
   * @param {any} thread_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_thread_comments_path: __jsr.r({"thread_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"threads"],[2,[7,"/"],[2,[3,"thread_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/comments/:id/undelete(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_undelete_comment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undelete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/threads/:id/unsubscribe(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_unsubscribe_thread_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"threads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/comments/:id/unvote(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_unvote_comment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unvote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /commontator/comments/:id/upvote(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  commontator_upvote_comment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"commontator"]],[7,"/"]],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"upvote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/check_for_consent(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  consent_profile_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"check_for_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /courses/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  course_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /courses(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  courses_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"courses"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /users/delete_account(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_account_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"delete_account"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/delete_correction(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_correction_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_correction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/delete_edge(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_edge_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete_edge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /notifications/destroy_all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_all_notifications_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"destroy_all"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/destroy_forum(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_forum_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"destroy_forum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/questionnaires/destroy_completion_message(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_lecture_completion_message_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[6,"destroy_completion_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /notifications/destroy_lecture_notifications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_lecture_notifications_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"destroy_lecture_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /notifications/destroy_news_notifications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_news_notifications_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"destroy_news_notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users/sign_out(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_user_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tags/:id/display_cyto(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  display_cyto_tag_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"display_cyto"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /items/:id/display(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  display_item_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"display"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/display(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  display_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"display"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /sections/:id/display(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  display_section_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"display"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /divisions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  division_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"divisions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /divisions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  divisions_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"divisions"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id/duplicate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  duplicate_questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /annotations/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_annotation_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"annotations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /areas/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_area_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /assignments/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_assignment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /chapters/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_chapter_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chapters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/edit_correction(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_correction_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_correction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /courses/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_course_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /divisions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_division_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"divisions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /items/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_item_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_lecture_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lessons/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_lesson_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_profile_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /programs/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_program_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_question_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/info_slides/:id/edit(.:format)
   * @param {any} questionnaire_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_questionnaire_info_slide_path: __jsr.r({"questionnaire_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"info_slides"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/slides/:id/edit(.:format)
   * @param {any} questionnaire_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_questionnaire_slide_path: __jsr.r({"questionnaire_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_quiz_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /referrals/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_referral_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /remarks/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_remark_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"remarks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /sections/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_section_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subjects/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_subject_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_submission_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tags/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tag_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /talks/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_talk_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"talks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /terms/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_term_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_tutorial_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/password/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_user_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_user_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/edit_vertex_targets(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_vertex_targets_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_vertex_targets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /watchlists/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_watchlist_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"watchlists"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /watchlist_entries/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_watchlist_entry_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"watchlist_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/elevate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  elevate_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"elevate"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /administration/profile(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  elevated_profile_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/enrich(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  enrich_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enrich"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/enter_code(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  enter_submission_code_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[6,"enter_code"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/enter_invitees(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  enter_submission_invitees_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enter_invitees"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /error(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  error_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"error"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /administration/exit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  exit_administration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"administration"],[2,[7,"/"],[2,[6,"exit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /announcements/:id/expel(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  expel_announcement_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"expel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id/export_statistics(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_statistics_questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"export_statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials/:id/assignments/:ass_id/export_teams(.:format)
   * @param {any} id
   * @param {any} ass_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  export_teams_to_csv_path: __jsr.r({"id":{"r":true},"ass_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[3,"ass_id"],[2,[7,"/"],[2,[6,"export_teams"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/feedback(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  feedback_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feedback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /feedbacks(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  feedbacks_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /events/fill_course_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_course_tags_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"fill_course_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/fill_media_select(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_media_select_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"fill_media_select"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/fill_medium_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_medium_preview_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fill_medium_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/fill_quizzable_area(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_quizzable_area_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fill_quizzable_area"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/fill_quizzable_preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_quizzable_preview_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fill_quizzable_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/fill_reassign_modal(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_reassign_modal_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"fill_reassign_modal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tags/fill_tag_select(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_tag_select_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"fill_tag_select"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/fill_teachable_select(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_teachable_select_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"fill_teachable_select"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users/fill_user_select(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  fill_user_select_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"fill_user_select"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/geogebra(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  geogebra_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"geogebra"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tags/:id/identify(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  identify_tags_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"identify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/import_toc(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  import_lecture_toc_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_toc"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/import_manuscript(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  import_manuscript_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_manuscript"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/import_script_items(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  import_script_items_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_script_items"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/inspect(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  inspect_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"inspect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /vouchers/:id/invalidate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  invalidate_voucher_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"vouchers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invalidate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/invite(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  invite_to_submission_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"invite"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /items/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  item_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"items"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /items(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  items_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /submissions/join(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  join_submission_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[6,"join"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/leave(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  leave_submission_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"leave"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/announcements(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_announcements_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"announcements"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/close_comments(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_close_comments_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"close_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/course(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_course_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"course"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/exercises(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_exercises_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"exercises"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/import_media(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_import_media_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"import_media"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/lesson_materials(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_lesson_materials_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lesson_materials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/material(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_material_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"material"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/miscellaneous(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_miscellaneous_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"miscellaneous"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/open_comments(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_open_comments_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"open_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/organizational(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_organizational_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"organizational"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:lecture_id/questionnaires(.:format)
   * @param {any} lecture_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_questionnaires_path: __jsr.r({"lecture_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"lecture_id"],[2,[7,"/"],[2,[6,"questionnaires"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/quizzes(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_quizzes_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quizzes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/remove_imported_medium(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_remove_imported_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_imported_medium"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/repetitions(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_repetitions_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"repetitions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/script(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_script_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"script"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/submissions(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_submissions_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submissions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/tutorial_overview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_tutorial_overview_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tutorial_overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/tutorials(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_tutorials_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tutorials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/worked_examples(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lecture_worked_examples_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"worked_examples"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lectures_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /lessons/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lesson_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lessons(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lessons_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/linearize(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  linearize_quiz_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"linearize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/list_generic_users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  list_generic_users_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"list_generic_users"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /referrals/list_items(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  list_items_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[6,"list_items"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /chapters/:id/list_sections(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  list_sections_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"chapters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"list_sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/lock_forum(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  lock_forum_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"lock_forum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  login_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /media(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  media_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /media/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /talks/:id/modify(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  modify_talk_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"talks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"modify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/move(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  move_submission_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"move"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /annotations/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_annotation_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"annotations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /announcements/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_announcement_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /answers/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_answer_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /areas/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_area_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"areas"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /assignments/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_assignment_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"assignments"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /chapters/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_chapter_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chapters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /divisions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_division_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"divisions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /feedbacks/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_feedback_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feedbacks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_lecture_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lessons/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_lesson_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lessons"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_medium_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /programs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_program_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/info_slides/new(.:format)
   * @param {any} questionnaire_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_questionnaire_info_slide_path: __jsr.r({"questionnaire_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"info_slides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/slides/new(.:format)
   * @param {any} questionnaire_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_questionnaire_slide_path: __jsr.r({"questionnaire_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/slides/:slide_id/answers/new(.:format)
   * @param {any} questionnaire_id
   * @param {any} slide_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_questionnaire_slide_answer_path: __jsr.r({"questionnaire_id":{"r":true},"slide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[3,"slide_id"],[2,[7,"/"],[2,[6,"answers"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_quiz_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:quiz_id/vertices/new(.:format)
   * @param {any} quiz_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_quiz_vertex_path: __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"vertices"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_rails_conductor_inbound_email_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_rails_conductor_inbound_email_source_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /sections/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_section_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subjects/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_subject_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_submission_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tags/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tag_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /talks/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_talk_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"talks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /terms/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_term_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_tutorial_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users/confirmation/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_confirmation_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/password/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/sign_up(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users/sign_in(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /watchlists/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_watchlist_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"watchlists"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /watchlist_entries/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_watchlist_entry_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"watchlist_entries"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /main/news(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  news_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"main"],[2,[7,"/"],[2,[6,"news"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /notifications/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  notification_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /notifications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  notifications_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /annotations/num_nearby_posted_mistake_annotations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  num_nearby_posted_mistake_annotations_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"annotations"],[2,[7,"/"],[2,[6,"num_nearby_posted_mistake_annotations"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/play(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  play_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"play"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tags/postprocess(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  postprocess_tags_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"postprocess"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id/preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  preview_questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/add_consent(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  profile_add_consent_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"add_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /profile/update(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  profile_update_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /programs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  program_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"programs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /programs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  programs_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"programs"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /announcements/:id/propagate(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  propagate_announcement_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"announcements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"propagate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/publish(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  publish_lecture_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/publish(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  publish_medium_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id/publish(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  publish_questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manifest(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  pwa_manifest_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manifest"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /questions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  question_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/info_slides/:id(.:format)
   * @param {any} questionnaire_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  questionnaire_info_slide_path: __jsr.r({"questionnaire_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"info_slides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/info_slides(.:format)
   * @param {any} questionnaire_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  questionnaire_info_slides_path: __jsr.r({"questionnaire_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"info_slides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/slides/:id(.:format)
   * @param {any} questionnaire_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  questionnaire_slide_path: __jsr.r({"questionnaire_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/slides/:slide_id/answers(.:format)
   * @param {any} questionnaire_id
   * @param {any} slide_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  questionnaire_slide_answers_path: __jsr.r({"questionnaire_id":{"r":true},"slide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"slides"],[2,[7,"/"],[2,[3,"slide_id"],[2,[7,"/"],[2,[6,"answers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:questionnaire_id/slides(.:format)
   * @param {any} questionnaire_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  questionnaire_slides_path: __jsr.r({"questionnaire_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"questionnaire_id"],[2,[7,"/"],[2,[6,"slides"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  questionnaires_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  quiz_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:quiz_id/vertices/:id(.:format)
   * @param {any} quiz_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  quiz_vertex_path: __jsr.r({"quiz_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"vertices"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:quiz_id/vertices(.:format)
   * @param {any} quiz_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  quiz_vertices_path: __jsr.r({"quiz_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"quiz_id"],[2,[7,"/"],[2,[6,"vertices"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
   * @param {any} signed_blob_id
   * @param {any} variation_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_blob_representation_path: __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
   * @param {any} signed_blob_id
   * @param {any} variation_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_blob_representation_proxy_path: __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
   * @param {any} inbound_email_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_incinerate_path: __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
   * @param {any} inbound_email_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_reroute_path: __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_sources_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/direct_uploads(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_direct_uploads_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/disk/:encoded_key/*filename(.:format)
   * @param {any} encoded_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_disk_service_path: __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /up(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_health_check_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"up"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mailgun_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mandrill/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mandrill_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mandrill/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mandrill_inbound_health_check_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/postmark/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_postmark_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/relay/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_relay_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_sendgrid_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
   * @param {any} signed_id
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_service_blob_path: __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
   * @param {any} signed_id
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_service_blob_proxy_path: __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /courses/:id/take_random_quiz(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  random_quiz_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"take_random_quiz"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /watchlists/rearrange(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rearrange_watchlist_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"watchlists"],[2,[7,"/"],[2,[6,"rearrange"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /questions/:id/reassign(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reassign_question_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /remarks/:id/reassign(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reassign_remark_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"remarks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/redeem_code(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  redeem_submission_code_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[6,"redeem_code"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /vouchers/redeem(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  redeem_voucher_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vouchers"],[2,[7,"/"],[2,[6,"redeem"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /referrals/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  referral_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"referrals"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /referrals(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  referrals_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"referrals"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/refresh_token(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  refresh_submission_token_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refresh_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/register_download(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  register_download_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"register_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/reject(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reject_submission_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /remarks/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remark_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"remarks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/remove_screenshot(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  remove_screenshot_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remove_screenshot"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/render_import_media(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_import_media_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_import_media"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/render_import_vertex(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_import_vertex_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_import_vertex"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/render_medium_actions(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_medium_actions_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_medium_actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/render_medium_tags(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_medium_tags_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_medium_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /courses/:id/render_question_counter(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_question_counter_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_question_counter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /questions/:id/render_question_parameters(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_question_parameters_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_question_parameters"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tags/render_tag_title(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_tag_title_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"render_tag_title"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/render_vertex_quizzable(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  render_vertex_quizzable_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"render_vertex_quizzable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/request_data(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  request_data_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"request_data"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  root_path: __jsr.r({}, [7,"/"]),

  /**
   * Generates rails route to
   * /courses/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_courses_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"courses"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /search/index(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"index"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_lectures_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_media_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tags/search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_tags_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /sections/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  section_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /sections(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sections_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/select_tutorial(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  select_tutorial_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"select_tutorial"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /terms/set_active_term(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_active_term_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[6,"set_active_term"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/questionnaires/set_codename(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_lecture_codename_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[6,"set_codename"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/questionnaires/set_completion_message(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_lecture_completion_message_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[6,"set_completion_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/set_level(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_quiz_level_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_level"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/set_root(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_quiz_root_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_root"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /question/:id/set_solution_type(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  set_solution_type_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"question"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"set_solution_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/show_accordion(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_accordion_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"show_accordion"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/show_correction(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_correction_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_correction"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/show_comments(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_media_comments_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/show_random_quizzes(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_random_quizzes_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_random_quizzes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id/show_manuscript(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_submission_manuscript_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_manuscript"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/show_subscribers(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  show_subscribers_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_subscribers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /sidekiq
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sidekiq_web_path: __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]),

  /**
   * Generates rails route to
   * /profile/star_lecture(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  star_lecture_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"star_lecture"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /main/start(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  start_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"main"],[2,[7,"/"],[2,[6,"start"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /media/:id/statistics(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  statistics_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /subjects/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subject_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subjects"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /subjects(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subjects_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subjects"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /submissions/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  submission_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /submissions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  submissions_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"submissions"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id/submit_answer(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  submit_answer_questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"submit_answer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/subscribe_lecture(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscribe_lecture_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"subscribe_lecture"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/subscribe(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  subscribe_lecture_page_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tags/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tag_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tags/modal(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tag_modal_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tags/:id/take_random_quiz(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tag_random_quiz_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"take_random_quiz"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tags_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id/take(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  take_questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"take"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/take(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  take_quiz_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"take"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /talks/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  talk_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"talks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /talks(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  talks_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"talks"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /users/teacher/:teacher_id(.:format)
   * @param {any} teacher_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  teacher_path: __jsr.r({"teacher_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"teacher"],[2,[7,"/"],[2,[3,"teacher_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /terms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  term_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"terms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /terms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  terms_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /forum
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_path: __jsr.r({}, [2,[7,"/"],[6,"forum"]]),

  /**
   * Generates rails route to
   * /forum/autocomplete-users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_autocomplete_users_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"autocomplete-users"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/category/:category_id(.:format)
   * @param {any} messageboard_id
   * @param {any} category_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_categories_messageboard_topics_path: __jsr.r({"messageboard_id":{"r":true},"category_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/preferences/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_edit_global_preferences_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"preferences"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/messageboards/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_edit_messageboard_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"messageboards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/preferences/edit(.:format)
   * @param {any} messageboard_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_edit_messageboard_preferences_path: __jsr.r({"messageboard_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[6,"preferences"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:id/edit(.:format)
   * @param {any} messageboard_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_edit_messageboard_topic_path: __jsr.r({"messageboard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:topic_id/:id/edit(.:format)
   * @param {any} messageboard_id
   * @param {any} topic_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_edit_messageboard_topic_post_path: __jsr.r({"messageboard_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_edit_private_topic_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:private_topic_id/:id/edit(.:format)
   * @param {any} private_topic_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_edit_private_topic_private_post_path: __jsr.r({"private_topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"private_topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:id/follow(.:format)
   * @param {any} messageboard_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_follow_messageboard_topic_path: __jsr.r({"messageboard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/preferences(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_global_preferences_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/read_state(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_mark_all_private_topics_read_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[6,"read_state"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/action/posts/:id/mark_as_read(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_mark_as_read_post_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"action"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/action/private_posts/:id/mark_as_read(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_mark_as_read_private_post_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"action"],[2,[7,"/"],[2,[6,"private_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_read"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/action/posts/:id/mark_as_unread(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_mark_as_unread_post_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"action"],[2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_unread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/action/private_posts/:id/mark_as_unread(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_mark_as_unread_private_post_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"action"],[2,[7,"/"],[2,[6,"private_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_unread"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/messageboards/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"messageboards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/admin/messageboard_groups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_groups_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messageboard_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/preferences(.:format)
   * @param {any} messageboard_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_preferences_path: __jsr.r({"messageboard_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id(.:format)
   * @param {any} messageboard_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_search_path: __jsr.r({"messageboard_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:id(/page-:page)(.:format)
   * @param {any} messageboard_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_topic_path: __jsr.r({"messageboard_id":{"r":true},"id":{"r":true},"page":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[2,[6,"page-"],[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:topic_id/:id(.:format)
   * @param {any} messageboard_id
   * @param {any} topic_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_topic_post_path: __jsr.r({"messageboard_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:topic_id/:post_id/preview(.:format)
   * @param {any} messageboard_id
   * @param {any} topic_id
   * @param {any} post_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_topic_post_preview_path: __jsr.r({"messageboard_id":{"r":true},"topic_id":{"r":true},"post_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:topic_id(.:format)
   * @param {any} messageboard_id
   * @param {any} topic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_topic_posts_path: __jsr.r({"messageboard_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"topic_id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id(/page-:page)(.:format)
   * @param {any} messageboard_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboard_topics_path: __jsr.r({"messageboard_id":{"r":true},"page":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[1,[2,[7,"/"],[2,[6,"page-"],[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * /forum/
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboards_path: __jsr.r({}, [2,[2,[7,"/"],[6,"forum"]],[7,"/"]]),

  /**
   * Generates rails route to
   * /forum/
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_messageboards_search_path: __jsr.r({}, [2,[2,[7,"/"],[6,"forum"]],[7,"/"]]),

  /**
   * Generates rails route to
   * /forum/admin/moderation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_moderate_post_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"moderation"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/admin/moderation/user/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_moderate_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/admin/moderation/activity(/page-:page)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_moderation_activity_path: __jsr.r({"page":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"activity"],[2,[1,[2,[7,"/"],[2,[6,"page-"],[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/admin/moderation/history(/page-:page)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_moderation_history_path: __jsr.r({"page":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"history"],[2,[1,[2,[7,"/"],[2,[6,"page-"],[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/messageboards/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_new_messageboard_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"messageboards"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/admin/messageboard_groups/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_new_messageboard_group_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"messageboard_groups"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/topics/new(.:format)
   * @param {any} messageboard_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_new_messageboard_topic_path: __jsr.r({"messageboard_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:topic_id/new(.:format)
   * @param {any} messageboard_id
   * @param {any} topic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_new_messageboard_topic_post_path: __jsr.r({"messageboard_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_new_private_topic_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:private_topic_id/new(.:format)
   * @param {any} private_topic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_new_private_topic_private_post_path: __jsr.r({"private_topic_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"private_topic_id"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/admin/moderation(/page-:page)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_pending_moderation_path: __jsr.r({"page":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"moderation"],[2,[1,[2,[7,"/"],[2,[6,"page-"],[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/posts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_post_permalink_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/topics/new/preview(.:format)
   * @param {any} messageboard_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_preview_new_messageboard_topic_path: __jsr.r({"messageboard_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:topic_id/new/preview(.:format)
   * @param {any} messageboard_id
   * @param {any} topic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_preview_new_messageboard_topic_post_path: __jsr.r({"messageboard_id":{"r":true},"topic_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/new/preview(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_preview_new_private_topic_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:private_topic_id/new/preview(.:format)
   * @param {any} private_topic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_preview_new_private_topic_private_post_path: __jsr.r({"private_topic_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"private_topic_id"],[2,[7,"/"],[2,[6,"new"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-posts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_private_post_permalink_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:id(/page-:page)(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_private_topic_path: __jsr.r({"id":{"r":true},"page":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[2,[6,"page-"],[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:private_topic_id/:id(.:format)
   * @param {any} private_topic_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_private_topic_private_post_path: __jsr.r({"private_topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"private_topic_id"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:private_topic_id/:private_post_id/preview(.:format)
   * @param {any} private_topic_id
   * @param {any} private_post_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_private_topic_private_post_preview_path: __jsr.r({"private_topic_id":{"r":true},"private_post_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"private_topic_id"],[2,[7,"/"],[2,[3,"private_post_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:private_topic_id(.:format)
   * @param {any} private_topic_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_private_topic_private_posts_path: __jsr.r({"private_topic_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"private_topic_id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_private_topics_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:topic_id/:id/quote(.:format)
   * @param {any} messageboard_id
   * @param {any} topic_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_quote_messageboard_topic_post_path: __jsr.r({"messageboard_id":{"r":true},"topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/private-topics/:private_topic_id/:id/quote(.:format)
   * @param {any} private_topic_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_quote_private_topic_private_post_path: __jsr.r({"private_topic_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"private-topics"],[2,[7,"/"],[2,[3,"private_topic_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"quote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_root_path: __jsr.r({}, [2,[2,[7,"/"],[6,"forum"]],[7,"/"]]),

  /**
   * Generates rails route to
   * /forum/messageboard-groups/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_show_messageboard_group_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"messageboard-groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/:id/unfollow(.:format)
   * @param {any} messageboard_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_unfollow_messageboard_topic_path: __jsr.r({"messageboard_id":{"r":true},"id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unfollow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/:messageboard_id/unread(.:format)
   * @param {any} messageboard_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_unread_messageboard_topics_path: __jsr.r({"messageboard_id":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[3,"messageboard_id"],[2,[7,"/"],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /forum/unread(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_unread_topics_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"unread"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /forum/admin/moderation/users/:id(/page-:page)(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_user_moderation_path: __jsr.r({"id":{"r":true},"page":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[1,[2,[7,"/"],[2,[6,"page-"],[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /forum/admin/moderation/users(/page-:page)(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  thredded_users_moderation_path: __jsr.r({"page":{},"format":{}}, [2,[2,[2,[7,"/"],[6,"forum"]],[7,"/"]],[2,[6,"admin"],[2,[7,"/"],[2,[6,"moderation"],[2,[7,"/"],[2,[6,"users"],[2,[1,[2,[7,"/"],[2,[6,"page-"],[3,"page"]]]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/toggle_thread_subscription(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  toggle_thread_subscription_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"toggle_thread_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /recede_historical_location(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  turbo_recede_historical_location_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /refresh_historical_location(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  turbo_refresh_historical_location_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /resume_historical_location(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  turbo_resume_historical_location_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /tutorials/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tutorial_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tutorials_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unauthenticated_root_path: __jsr.r({}, [7,"/"]),

  /**
   * Generates rails route to
   * /lectures/:id/unlock_forum(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unlock_forum_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unlock_forum"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /profile/unstar_lecture(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unstar_lecture_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"unstar_lecture"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /profile/unsubscribe_lecture(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  unsubscribe_lecture_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"unsubscribe_lecture"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /readers/update_all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_all_readers_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"readers"],[2,[7,"/"],[2,[6,"update_all"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /annotations/update_annotations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_annotations_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"annotations"],[2,[7,"/"],[2,[6,"update_annotations"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/update_branching(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_branching_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[6,"update_branching"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /quizzes/:id/update_default_target(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_default_target_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"quizzes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_default_target"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/update_editors(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_editors_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_editors"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/disk/:encoded_token(.:format)
   * @param {any} encoded_token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_rails_disk_service_path: __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /readers/update(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_reader_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"readers"],[2,[7,"/"],[2,[6,"update"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /questionnaires/:id/update_slide_position(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_slide_position_questionnaire_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"questionnaires"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_slide_position"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /media/update_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_tags_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media"],[2,[7,"/"],[2,[6,"update_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /lectures/:id/update_teacher(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_teacher_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"lectures"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_teacher"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users/confirmation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_confirmation_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users/password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /users/sign_in(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  users_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /quiz_certificates/validate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  validate_certificate_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"quiz_certificates"],[2,[7,"/"],[2,[6,"validate"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /tutorials/validate_certificate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  validate_certificate_as_tutor_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tutorials"],[2,[7,"/"],[2,[6,"validate_certificate"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /vouchers/verify(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  verify_voucher_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vouchers"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /vouchers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  vouchers_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vouchers"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /watchlists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  watchlist_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"watchlists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /watchlist_entries(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  watchlist_entries_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"watchlist_entries"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /watchlist_entries/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  watchlist_entry_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"watchlist_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /watchlists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  watchlists_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"watchlists"],[1,[2,[8,"."],[3,"format"]]]]])}
,
    });
})();
